import { create } from 'zustand'
import { shopApi } from '~/src/shared/api/shopApi'

export const useCartStore = create((set, get) => ({
  cart: { items: [], total_items: 0, subtotal_amount: 0 },
  loading: false,
  error: null,
  hydrate: async () => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.cart()
      set({ cart: response.cart, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
    }
  },
  addItem: async (productId, quantity = 1) => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.addCartItem(productId, quantity)
      set({ cart: response.cart, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
  updateItem: async (itemId, quantity) => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.updateCartItem(itemId, quantity)
      set({ cart: response.cart, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
  removeItem: async (itemId) => {
    return get().updateItem(itemId, 0)
  },
  clear: async () => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.clearCart()
      set({ cart: response.cart, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
}))
